import { z } from "zod";

export const logisticsConfigSchema = z.object({
  equipmentManagement: z.object({
    enabled: z.boolean(),
  }),
});
